import React from "react";
import { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";

interface Props {
  tableHeader: TableHeadersType[];
  extraHeader?: boolean;
  textCenter?: boolean;
}
const BomTableheader = ({
  tableHeader = [],
  extraHeader,
  textCenter,
}: Props) => {
  return (
    <tr>
      {tableHeader.map((item: any, index) => {
        if (item) {
          return (
            <th
              className={`${textCenter ? "text-center" : null}`}
              key={item?.value}
              style={{ width: item?.width ? item.width : "120px",paddingLeft:item.value==="amount" ? "0px" :"12px"}}
            >
              {item?.label}
            </th>
          );
        } else {
          return null;
        }
      })}
      {extraHeader && <th></th>}
    </tr>
  );
};

export default BomTableheader;
